import { FcApprove } from "react-icons/fc";
import "./Notifications.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  GetAllNotificationsWithType,
  ReadNotifications,
} from "../../../config/LiveApi";
import { useEffect, useState } from "react";
import Spinner from "../../Spin/Spinner";
const SuspiciousTnx = () => {
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [notifications, setNotifications] = useState(showNotifications);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("error_webhook");
  const navigate = useNavigate();

  const handleMarkAsRead = async (n) => {
    try {
      await ReadNotifications(n._id);
      setNotifications((prev) =>
        prev.map((m) => (m._id === n._id ? { ...n, read: true } : m)),
      );
      setShowNotifications((prev) =>
        prev.map((m) => (m._id === n._id ? { ...n, read: true } : m)),
      );
      // navigate(`/change-status?orderId=${n.orderId}`, { replace: true });
    } catch (err) {
      console.error("Failed to mark as read:", err);
    }
  };

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await GetAllNotificationsWithType(type, page);
      setShowNotifications(response);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, [page]);

  return (
    <div className="notification-list-container">
      <div className="all-notifications">
        {loading ? (
          <div className="spinner-wrapper">
            <Spinner />
          </div>
        ) : showNotifications.length === 0 ? (
          <div className="no-data-found">No notifications found...</div>
        ) : (
          <>
            <div className="notification-list">
              {showNotifications.map((n, index) => (
                <div
                  key={index}
                  className={`notification-item ${n.read ? "read" : "unread"}`}
                  onClick={() => !n.read && handleMarkAsRead(n)}
                >
                  <div className="icon-area">🔔</div>
                  <div className="text-area">
                    <div className="message-notification">{n.message}</div>
                    <div className="time-notification">{n.time}</div>
                  </div>
                  <div className="action-area">
                    {n.read ? (
                      <span className="done-text">✅ Done</span>
                    ) : (
                      <button
                        className="delete-btn-notification"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMarkAsRead(n);
                        }}
                      >
                        <FcApprove />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {showNotifications.length > 50 && (
              <div className="pagination-container">
                <button
                  className="pagination-btn"
                  disabled={page === 1}
                  onClick={() => setPage((prev) => prev - 1)}
                >
                  Previous
                </button>

                <span className="page-number">Page {page}</span>

                <button
                  className="pagination-btn"
                  disabled={showNotifications.length < 10}
                  onClick={() => setPage((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SuspiciousTnx;
